enum LocationValueType {
  DEPARTMENT = 'H',
  PROJECT = 'P',
}

export default LocationValueType;
